<template>
    <div class="create">
        <el-dialog title="详情" :visible.sync="dialogVisible" width="865px" :before-close="handleClose">
            <div class="main" v-loading="load">
                <div v-if="info">
                    <el-form label-width="100px" inline label-position="left">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="编号ID："> {{ info.detail.id }} </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="预警时间："> {{ info.detail.create_time }}</el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="平台名称"> {{ info.platform.name }} </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="预警类型：">
                                    <p>{{ info.detail.extra || activeName == 1 ? "价格上限" : "价格下限" }}</p>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="预警内容：">
                                    <p style="color: red">
                                        {{
                                            `${info.detail.type == 1 ? "超出上限价" : "超出下限价"}&nbsp;&nbsp;&nbsp;&nbsp;当前价格：${info.detail.finial_price}&nbsp;&nbsp;&nbsp;&nbsp;${
                                                info.detail.type == 1 ? "上限价" : "下限价"
                                            }：${info.detail.waring_price}`
                                        }}
                                    </p>
                                    <el-form-item>
                                        <el-link @click="openUrl(info.detail.url)">{{ info.detail.url }}</el-link>
                                    </el-form-item>
                                    <el-form-item>
                                        <span class="shop" v-if="info.detail.shop_name">{{ info.detail.shop_name }}</span>
                                        <el-link type="primary" @click="viewImage(info.detail.image)">点击查看</el-link></el-form-item
                                    >
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24"> </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24"> </el-col>
                        </el-row>
                    </el-form>
                    <div class="logBox" v-if="info.history.length > 0">
                        <p class="subtitle">历史记录</p>
                        <div class="logList">
                            <el-divider></el-divider>
                            <el-form label-width="100px" inline label-position="left" v-for="(item, index) in info.history" :key="index">
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="编号ID："> {{ item.id }} </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="监控时间："> {{ item.create_time }}</el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="平台名称"> {{ info.platform.name }} </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="预警类型：">
                                            <p>{{ item.extra || activeName == 1 ? "价格上限" : "价格下限" }}</p>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item label="预警内容：">
                                            <el-form-item>
                                                <p style="color: red">
                                                    {{
                                                        `${item.type == 1 ? "超出上限价" : "超出下限价"}&nbsp;&nbsp;&nbsp;&nbsp;当前价格：${item.finial_price}&nbsp;&nbsp;&nbsp;&nbsp;${
                                                            item.type == 1 ? "上限价" : "下限价"
                                                        }：${item.waring_price}`
                                                    }}
                                                </p>
                                            </el-form-item>
                                            <el-form-item>
                                                <el-link @click="openUrl(item.url)">{{ item.url }}</el-link>
                                            </el-form-item>
                                            <el-form-item>
                                                <span class="shop" v-if="info.detail.shop_name">{{ info.detail.shop_name }}</span>
                                                <el-link type="primary" @click="viewImage(item.image)">点击查看</el-link></el-form-item
                                            >
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24"> </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24"> </el-col>
                                </el-row>
                                <el-divider></el-divider>
                            </el-form>
                        </div>
                    </div>
                </div>
                <el-empty description="暂无内容！" v-else></el-empty>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose" type="" size="medium" plain>关 闭</el-button>
            </span>
        </el-dialog>
        <!-- 查看图片 -->
        <el-dialog :visible.sync="imgDialogVisible">
            <img v-if="dialogImageUrl" width="100%" :src="dialogImageUrl" alt="" />
            <el-empty v-else description="暂无图片！"></el-empty>
        </el-dialog>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
export default {
    name: "Detail",
    data() {
        return {
            dialogVisible: false,
            imgDialogVisible: false,
            dialogImageUrl: "",
            info: null,
            load: false,
            tag: 0,
        };
    },
    props: ["activeName"],
    computed: {
        ...mapGetters(["getToken"]),
    },
    methods: {
        ...mapActions({
            getProductPriceDetail: "brand/getProductPriceDetail", //  授权详情
        }),
        openUrl(url) {
            window.open(url);
        },
        getDetail(id) {
            this.load = true;
            this.getProductPriceDetail({ id: id, token: this.getToken }).then(({ data }) => {
                this.load = false;
                if (data.code == 1) {
                    this.info = data.data;
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        viewImage(url) {
            this.imgDialogVisible = true;
            this.dialogImageUrl = url;
        },
        handleClose() {
            this.info = null;
            this.dialogVisible = false;
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__body {
    height: 480px;
    overflow-y: auto;
    &::-webkit-scrollbar-track-piece {
        background: #d3dce6;
    }

    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-thumb {
        background: #99a9bf;
        border-radius: 20px;
    }
}
.main {
    .logBox {
        padding: 15px;
        background: #eee;
        .subtitle {
            color: #333;
            font-size: 16px;
            margin-bottom: 12px;
        }
        .logList {
            ::v-deep .el-descriptions__body {
                background: #eee;
            }
        }
    }
}
.red {
    color: #f00;
}
::v-deep .el-form-item {
    margin-bottom: 0 !important;
    width: 100%;
}
.el-col-24 {
    ::v-deep .el-form-item__content {
        width: 80% !important;
    }
}
::v-deep .el-link {
    line-height: 24px;
}
.shop {
    margin-right: 20px;
}
.el-col {
    overflow: hidden;
    .el-form-item {
        margin: 0 !important;
    }
}
</style>